module.exports = __webpack_public_path__ + "static/Classroom-Activity-1-3-Competing-and-Comparing-Looks-0b170f6fdee5a5c88cec175773c52507.pdf";